module.exports = __webpack_public_path__ + "static/media/logo.98647df0.svg";